/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RecipientProviderStatus = {
    Live: 'live',
    Healed: 'healed',
    NeedsReview: 'needs_review',
    Unavailable: 'unavailable'
} as const;
export type RecipientProviderStatus = typeof RecipientProviderStatus[keyof typeof RecipientProviderStatus];


export function RecipientProviderStatusFromJSON(json: any): RecipientProviderStatus {
    return RecipientProviderStatusFromJSONTyped(json, false);
}

export function RecipientProviderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientProviderStatus {
    return json as RecipientProviderStatus;
}

export function RecipientProviderStatusToJSON(value?: RecipientProviderStatus | null): any {
    return value as any;
}

